<script>
export default {
  name: "IconEnter"
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fill-rule="evenodd">
      <rect fill="#cdd7e0" width="16" height="16" rx="2" />
      <path
        d="M13 8.33V3.8a.8.8 0 00-1.6 0v4.53c0 .45-.36.82-.8.82H5.73l1.44-1.47a.83.83 0 000-1.16.8.8 0 00-1.14 0l-2.8 2.87a.83.83 0 000 1.16l2.8 2.87a.8.8 0 001.14 0 .83.83 0 000-1.16l-1.44-1.47h4.87c1.33 0 2.4-1.1 2.4-2.46z"
        fill="#FFF"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
